// src/hooks/useMediaQuery.js

import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Check if window is defined (for SSR environments, though not strictly needed for CRA)
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia(query);
      setMatches(mediaQuery.matches); // Set initial state

      const handler = (event) => setMatches(event.matches);
      mediaQuery.addEventListener('change', handler); // Listen for changes

      return () => {
        mediaQuery.removeEventListener('change', handler); // Clean up
      };
    }
  }, [query]); // Re-run effect if the query string changes

  return matches;
};

export default useMediaQuery;